export default {
  'demoAccount.title': 'Thông báo',
  'demoAccount.content': 'Hãy bấm Đăng nhập để vào tài khoản của bạn hoặc chờ {{time}}s.',
  'demoAccount.demo': 'DEMO',
  'demoAccount.login': 'ĐĂNG NHẬP',
}
